<template>
  <div>
    <div class="cominfo-header">企业中心
      <span>/</span><span>课程中心</span><span>/</span><span>
        <router-link to="/Company/MyCurriculum">自研课程</router-link>
      </span><span>/</span><span>{{ruleForm.id?'编辑':'新建'}}课程</span>
    </div>
    <div class="comUserInfo" v-loading="loading">
      <div class="comUserInfo-header">
        <el-button type="primary" @click="onSave">保存</el-button>
      </div>
      <div class="comUserInfo-conts">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
          style="width: 90%;margin: 20px 0px 20px 100px;text-align: left;padding-bottom: 50px;">
          <el-form-item label="标题：" prop="cname">
            <el-input v-model="ruleForm.cname" placeholder="请输入标题"></el-input>
          </el-form-item>
          <el-form-item label="封面：" prop="img">
            <el-upload action="/safety/file/attachment/upload_new.htm" list-type="picture-card" :show-file-list="false"
              :multiple="false" :on-success="handleAvatarSuccess" :on-remove="delFile">
              <img v-if="ruleForm.img" :src="wjSrc+ruleForm.img" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-row>
            <el-col :span="5">
              <el-form-item label="课时：" prop="ks">
                <el-input-number v-model="ruleForm.ks" style="text-align: left;width: 100%;" :controls="false"
                  placeholder="请输入课时"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="培训类别：" prop="ontype">
                <!-- @change="getParName" -->
                <el-select v-model="ruleForm.ontype" placeholder="请选择培训类别" style="width: 100%;">
                  <el-option v-for="item in options" :key="item.uniqueCode" :label="item.text" :value="item.uniqueCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="培训讲师：" prop="author">
                <el-input v-model="ruleForm.author" placeholder="请输入培训讲师"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="开启防作弊：" prop="havezb" label-width="100px" style="display: inline-block;width: 50%;">
                <el-radio-group v-model="ruleForm.havezb">
                  <el-radio :disabled="disabled" v-for="(k,i) in 2" :label="i" :value="i" :key="i">{{i==0?'否':'是'}}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="有效期：">
            <el-date-picker style="width: 100%;" v-model="rangeTime" value-format="yyyy-MM-dd" type="daterange"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="上传视频：" prop="filepath">
            <upload-al @changeKc="changeKc" :kcfile="kcfile"></upload-al>
          </el-form-item>
          <el-form-item label="视频时长：" prop="xstime">
            <el-input v-model="ruleForm.xstime" :disabled="true" placeholder="请输入视频时长"></el-input>
          </el-form-item>
          <el-form-item label="上传课件：">
            <el-upload class="upload-demo" :data="kjparams" action="/safety/file/attachment/upload_new.htm"
              :multiple="true" :on-remove="handlKjRemove" :on-success="handlKjSuccess" :file-list="listkjs">
              <el-button type="primary">点击上传课件</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="简介：" prop="description">
            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="ruleForm.description">
            </el-input>
          </el-form-item>
          <el-form-item label="图文详情：">
            <quill-editor class="myQuillEditor" v-model="ruleForm.conts" ref="myQuillEditor" :options="editorOption">
            </quill-editor>

            <!-- <quill-editor ref="text" v-model="" class="myQuillEditor" :options="editorOption" /> -->
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    quillEditor,
    Quill
  } from 'vue-quill-editor'
  import {
    container,
    ImageExtend,
    QuillWatch
  } from 'quill-image-extend-module';
  Quill.register('modules/ImageExtend', ImageExtend);
  // import ImageResize from 'quill-image-resize-module' //添加
  import ImageResize from "quill-blot-formatter"; //改为引入quill-blot-formatter就可以了
  window.Quill = Quill;
  Quill.register('modules/imageResize', ImageResize) //添加

  import {
    getItype,
  } from '@/assets/js/common.js';
  import UploadAl from '../common/UploadAl';

  export default {
    props: ['collapse', 'wjSrc', 'currentUser'],
    data() {
      var validatePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('联系方式不能为空！'));
        } else if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
          callback(new Error('联系方式有误，请重新输入！'));
        } else {
          callback();
        }
      };
      return {
        disabled: false,
        uploadParams: {

        },
        kjparams: {
          "dir": "zxkt",
          "businessClass": "kcfjk",
          "businessId": "kc",
          "ispdf": "1",
          "dataId": ''
        },
        rules: {
          cname: [{
            required: true,
            message: '课程名称不能为空',
            trigger: 'blur'
          }],
          parentid: [{
            required: true,
            message: '课程类别不能为空',
            trigger: 'blur'
          }],
          author: [{
            required: true,
            message: '培训讲师不能为空',
            trigger: 'blur'
          }],
          filepath: [{
            required: true,
            message: '视频不能为空',
            trigger: 'blur'
          }],
        },
        listkjs: [], //课件列表
        ruleForm: {
          id: '',
          itype: '',
          cname: '',
          author: '',
          xstime: '00:00:00',
          img: '',
          filepath: '',
          filesize: '',
          endtime: '',
          begintime: '',
          description: '',
          conts: '',
          producttype: '1',
          ks: 1,
          havezb:0
        },
        rangeTime: [],
        circleUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
        options: [],
        loading: false,
        editorOption: {
          placeholder: '请输入文本...',
          modules: {
            ImageExtend: {
              loading: true,
              methods: 'get', // 必填参数 图片上传方式
              name: 'file', // 必填参数 文件的参数名
              action: '/safety/file/attachment/upload_new.htm',
              response: (res) => {
                return this.wjSrc + res.data.filePath;
              }
            },
            imageResize: { //添加
              displayStyles: { //添加
                backgroundColor: 'black',
                border: 'none',
                color: 'white'
              },
              modules: ['Resize', 'DisplaySize', 'Toolbar'] //添加
            },
            toolbar: {
              container: container,
              handlers: {
                'image': function() {
                  // console.log(this.quill.id)
                  QuillWatch.emit(this.quill.id)
                }
              }
            }
          },
        },
        uuid: '',
        updataNum: 0,
        percentage: 0,
        kcfile: {}
      }
    },
    methods: {
      handleAvatarSuccess(res, file) {
        if (this.ruleForm.img) {
          this.delFile(this.ruleForm.img);
        }
        this.$set(this.ruleForm, 'img', res.data.filePath);
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 1;
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 1MB!');
        }
        return isJPG && isLt2M;
      },
      getUUid() {
        var weishu = 32;
        var zimuarr = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r',
          's', 't', 'u', 'v', 'w', 'x', 'y', 'z'
        ];
        var shuziarr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
        var strs = '';
        for (var i = 0; i < weishu; i++) {
          var jioushu = parseInt(Math.random() * 2);
          //奇数
          if (jioushu % 2 > 0) {
            var number1 = parseInt(Math.random() * 26);
            strs += zimuarr[number1]
          } else {
            //偶数
            var number2 = parseInt(Math.random() * 10);
            strs += shuziarr[number2]
          }
        }
        return strs;
      },
      onSave: function() {
        var $this = this;
        // this.loading = true;

        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            if(this.rangeTime[0]){
              this.$set(this.ruleForm, 'begintime', this.rangeTime[0] + ' 00:00:00');
            }
            if(this.rangeTime[1]){
              this.$set(this.ruleForm, 'endtime', this.rangeTime[1] + ' 23:59:59');
            }

            var url = '/kt/ktCurriculum/add.htm';
            if (this.$route.query.id) {
              url = '/kt/ktCurriculum/update.htm';
            };

            this.$axios.post(url, this.$qs.stringify(this.ruleForm))
              .then(res => {
                var data = res.data;
                this.loading = false;
                if (data.stat == '1') {
                  this.$message({
                    message: '课程保存成功！请稍后再列表获取本课程视频的时长',
                    type: 'success',
                    duration: 1000,
                    onClose: function() {
                      $this.$router.push('/Company/MyCurriculum');
                    }
                  });
                } else {
                  this.$message.error(data.message);
                }
              })
          } else {
            return false;
          }
        });
      },
      getData: function(id) {
        this.$axios.get('/kt/productInfo/detail2.htm?id=' + id).then(res => {
          var data = res.data;
          this.loading = false;
          if (data.stat == '1') {
            this.ruleForm = {
              id: data.data.id,
              itype: data.data.itype,
              ontype: data.data.ontype,
              itypeName: data.data.itypeName,
              ontypeName: data.data.ontypeName,
              cname: data.data.cname,
              author: data.data.author,
              xstime: data.data.xstime,
              img: data.data.img,
              filepath: data.data.filepath,
              filesize: data.data.filesize,
              endtime: data.data.endtime ? (data.data.endtime.substring(0, 10)) : '',
              begintime: data.data.begintime ? (data.data.begintime.substring(0, 10)) : '',
              description: data.data.description,
              conts: data.data.productinfocont ? data.data.productinfocont.conts : '',
              producttype: '1',
              ordernum: data.data.ordernum,
              ks: data.data.ks,
              havezb: data.data.havezb,
            };
            if (data.data.begintime && data.data.endtime) {
              this.rangeTime = [data.data.begintime, data.data.endtime];
            }

            if (data.data.listkjs) {
              data.data.listkjs.map((item) => {
                item.name = item.cname;
                item.url = this.wjSrc + item.filepath;
              })
              this.listkjs = data.data.listkjs;
            }
            if (data.data.ordernum && data.data.filepath) {
              sessionStorage.setItem('videoid', data.data.filepath);
              this.kcfile = {
                name: data.data.ordernum
              };
            } else {
              sessionStorage.setItem('videoid', '');
            }
          } else {
            this.$message.error(data.message);
          }
        });
      },
      delFile: function(filePath, flag) {
        var fileId = ''
        if (flag == 'id') {
          fileId = filePath;
        } else {
          var arr = filePath.split('/');
          var arr0 = arr[arr.length - 1].split('.');
          fileId = arr0[0];
        };
        this.$axios.post('/file/attachment/del.htm', this.$qs.stringify({
          id: fileId
        })).then(
          res => {
            var data = res.data;
            if (data.stat == '1') {

            } else {
              // this.$message.error(data.message);
            }
          })
      },
      changeKc: function(filepath, ordernum, xstime) {
        this.$set(this.ruleForm, 'filepath', filepath);
        this.$set(this.ruleForm, 'ordernum', ordernum);
        this.$set(this.ruleForm, 'xstime', xstime);
      },
      handlKjSuccess: function(res, file, fileList) {
        if (res.stat == '1') {
          this.listkjs = fileList;
          // var kcfile = [];
          // fileList.map((item) => {
          //   kcfile.push(item.response.data.id);
          // });
          // this.$set(this.ruleForm, 'kcfile', kcfile.join(','));
        } else {
          fileList.splice(fileList.length - 2, 1)
          this.$message.error(res.message);
        }
      },
      // 获取培训类别名称
      getParName: function(val) {
        var list = this.options;
        list.map((item) => {
          if (item.uniqueCode == val) {
            this.$set(this.ruleForm, 'parentname', item.text);
          }
        });
      },
      // 粘贴的图片向后台上次
      uploadToServer(file, callback) {
        var xhr = new XMLHttpRequest()
        var formData = new FormData()
        formData.append('file', file)
        xhr.open('post', '/safety/file/attachment/upload_new.htm')
        xhr.withCredentials = true
        xhr.responseType = 'json'
        xhr.send(formData)
        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4 && xhr.status === 200) {
            callback(xhr.response)
          }
        }
      },
      uploadAttachment(response, file, fileList) {
        // 保存文件信息
        if (response.stat == 1) {
          // 获取富文本组件实例
          let quill = this.$refs.myQuillEditor.quill
          // 获取光标所在位置
          let length = quill.getSelection().index
          // 插入图片  res.info为服务器返回的图片地址
          quill.insertEmbed(length, 'image', this.wjSrc + response.data.filePath)
          quill.setSelection(length + 1);
        } else {
          this.$message.error(response.status.message)
        }
        // 清空文件列表
        this.uploadList = []
      },
      getKjlist: function() {
        var params = {
          dataId: this.kjparams.dataId,
          bType: this.kjparams.businessClass,
          bId: this.kjparams.businessId
        };
        this.$axios.get('/file/attachment/list.htm?' + this.$qs.stringify(params)).then(res => {
          var data = res.data.rows;
          this.loading = false;
          this.listkjs = data.map((item) => {
            return {
              ...item,
              name: item.fileName
            }
          });
        });
      },
      handlKjRemove(file, filelist) {
        this.listkjs = filelist;
        this.delFile(file.id, 'id');
      },
      getPxitype: function() {
        // ZXKT_pxitype   之前的字典
        this.$axios.get('/system/datadict/tree.htm?supCode=ZXKT_producttype_5', {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          this.options = data;
        })
      }
    },
    created: function() {
      // 人员详情
      if (this.$route.query.id) {
        this.loading = true;
        this.$set(this.kjparams, 'dataId', this.$route.query.id);
        this.getKjlist(this.$route.query.id);
        this.getData(this.$route.query.id);
        // 获取课件列表
      } else {
        var newid = this.getUUid();
        sessionStorage.setItem("videoid",'');
        this.$set(this.ruleForm, 'id', newid);
        this.$set(this.kjparams, 'dataId', newid);
      }
      this.getPxitype();
      // 滚动条滚动到最顶部
      $('#app').animate({
        scrollTop: 110
      }, 300);
    },
    components: {
      quillEditor,
      UploadAl
    },
    mounted() {
      //  自定义粘贴图片功能
      let quill = this.$refs.myQuillEditor.quill;
      this.$forceUpdate()
      quill.root.addEventListener('paste', evt => {
        if (evt.clipboardData && evt.clipboardData.files && evt.clipboardData.files.length) {
          evt.preventDefault();
          [].forEach.call(evt.clipboardData.files, file => {
            if (!file.type.match(/^image\/(gif|jpe?g|a?png|bmp)/i)) {
              return
            }
            this.uploadToServer(file, (res) => {
              // 获取光标内容
              var range = quill.getSelection()
              if (range) {
                this.uploadAttachment(res, file, null)
                //  将光标移动到图片后面
                this.$refs.myQuillEditor.quill.setSelection(range.index + 1)
              }
            })
          })
        }
      }, false)
    }
  }
</script>
<style>
  .comUserInfo {
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin-top: 20px;
  }

  .comUserInfo-header {
    height: 70px;
    border-bottom: 1px solid #efefef;
    padding: 0 30px;
    text-align: right;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
  }

  .avatar {
    width: 100px!important;
    height: 140px!important;
  }

  .el-input-number .el-input__inner {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/CurriculumInfo.vue